// Contract addresses
export const TEE_REGISTRY_ADDRESS = "0x7D2efD3823E120e6459abc2706BB9a050D08719e";
export const ATTESATION_VERIFICATION_RECORD_ADDRESS = "0xe2e74C434DF808074428a73aFe922aEb85b278fa";

// Contract ABIs
export const TEE_REGISTRY_ABI = require("../abi/TEERegistry.abi.json");
export const ATTESATION_VERIFICATION_RECORD_ABI = require("../abi/AttestationVerificationRecord.abi.json");

// RPC URL for Ethereum Sepolia
export const RPC_URL_SEPOLIA = "https://eth-sepolia.g.alchemy.com/v2/t4Tylj9lN2WwI_vMZVsg46Uc7yiqyDjZ";

// API Endpoints
export const HACK_TEE_API_ENDPOINT = "https://d3d457f80a1e5c9f51c27dcc7125ba21f2418e08-8080.dstack-prod5.phala.network/toggle-anomaly"; 